import React from 'react';
import { FormattedMessage } from 'react-intl';
import TableRow from './TableRow';
import Loader from '../../Utils/Loader';
import Empty from './Empty';
import MobileCard from './MobileCard';

import classes from './styles.module.css';

function AccountsList({ data, currentId, isLoading }) {
    if (isLoading) return <Loader />;

    if (!Boolean(data.length)) return <Empty />;

    return (
        <React.Fragment>
            <div className={classes.Scroll}>
                <table className={classes.Table}>
                    <thead>
                        <tr>
                            <th className={classes.HeaderCenter}>
                                <FormattedMessage id='AccountsList.table.id' defaultMessage='no translate'/>
                            </th>
                            <th className={classes.HeaderCell}>
                                <FormattedMessage id='AccountsList.table.createdAt' defaultMessage='no translate'/>
                            </th>
                            <th className={classes.HeaderCell}>
                                <FormattedMessage id='AccountsList.table.user' defaultMessage='no translate'/>
                            </th>
                            <th className={classes.HeaderCell}>
                                <FormattedMessage id='AccountsList.table.email' defaultMessage='no translate'/>
                            </th>
                            <th className={classes.HeaderCenter}>
                                <FormattedMessage id='AccountsList.table.status' defaultMessage='no translate'/>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {data.map(function (el) {
                            return (
                                <TableRow key={el.id} data={el} currentId={currentId}/>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            {data.map(function (el) {
                return <MobileCard key={el.id} data={el} currentId={currentId}/>;
            })}
        </React.Fragment>
    );
}

export default AccountsList;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/AccountsList/index.js